/* In-memory token holder.
   The axios interceptors read the tokens from here so they do not have to
   import the redux store (avoids a circular import: store → saga → service →
   apiClient → store). The auth reducer and App keep this in sync on login,
   logout and refresh, and re-hydrate it from the persisted store on boot. */

let accessToken: string | null = null;
let refreshToken: string | null = null;
let onUnauthorized: ((reason: { code: string; message: string } | null) => void) | null = null;
let onRefreshed: ((t: { accessToken: string; refreshToken: string; mustChangePassword: boolean }) => void) | null = null;

export const setAccessToken = (token: string | null): void => {
  accessToken = token;
};
export const getAccessToken = (): string | null => accessToken;

export const setRefreshToken = (token: string | null): void => {
  refreshToken = token;
};
export const getRefreshToken = (): string | null => refreshToken;

/** Registered by the app once; used when a session cannot be continued. */
export const setUnauthorizedHandler = (
  fn: ((reason: { code: string; message: string } | null) => void) | null,
): void => {
  onUnauthorized = fn;
};

export const handleUnauthorized = (reason: { code: string; message: string } | null = null): void => {
  if (onUnauthorized) onUnauthorized(reason);
};

/** Registered by the app once; told when the interceptor has refreshed the tokens. */
export const setRefreshedHandler = (
  fn: ((t: { accessToken: string; refreshToken: string; mustChangePassword: boolean }) => void) | null,
): void => {
  onRefreshed = fn;
};

export const handleRefreshed = (t: { accessToken: string; refreshToken: string; mustChangePassword: boolean }): void => {
  if (onRefreshed) onRefreshed(t);
};
